import { stringify } from 'qs'

const headers = {
  'Content-Type': 'application/json'
}

const checkStatus = async (response) => {
  if (response.ok) {
    return response
  }

  const error = new Error(response.statusText)
  error.status = response.status
  const errorResponse = await response.text()

  try {
    error.response = JSON.parse(errorResponse)
  } catch (e) {
    error.response = { error: errorResponse }
  }

  throw error
}

const parseJSON = (response) => {
  if (response.headers && response.headers.get('X-Page')) {
    return response.json().then(json => ({
      pagination: {
        page: parseInt(response.headers.get('X-Page'), 10),
        pageCount: parseInt(response.headers.get('X-Page-Count'), 10),
        pageSize: parseInt(response.headers.get('X-Page-Size'), 10)
      },
      items: json
    }))
  }

  return response.json()
}

export default ({ path, method, params, bodyParams, cookie }) => {
  const requestAttributes = {
    method,
    headers: {
      ...headers,
      ...cookie ? { cookie } : {}
    }
  }

  if (bodyParams) {
    requestAttributes.body = JSON.stringify(bodyParams)
  }

  const query = stringify(params) || ''

  return fetch(`${path}${query ? `?${query}` : ''}`, requestAttributes)
    .then(checkStatus)
    .then(parseJSON)
}



// WEBPACK FOOTER //
// ./src/libs/http/fetch.js